import React, { useState } from 'react'
import './challenges.scss'
import Button from '../../../shared/src/components/atoms/button/button';
import { IChallenges } from 'adapters/challenges.adapter';
import { Link } from 'react-router-dom';
import {findCurrentChallenge, isSubChallengesCompleted} from 'utils/challengesUtils';

export interface IChallengesProps {
	challenges: IChallenges[];
}

const Challenges = (props: IChallengesProps) => {

	const { challenges } = props;	
	const currentChallenge = findCurrentChallenge(challenges);	

	return (
		<section className={`challenges`}>
			<header className="challenges__nav">
				{challenges.map((challenge: any, idx: number) => (
					<div
						className="challenges__nav__item"
						style={{
							backgroundColor: isSubChallengesCompleted(challenges, idx) ? '#EE2B7B' : '#EEEEEE',
							"--main-color": isSubChallengesCompleted(challenges, idx) ? 'white' : '#96A5BF'
						} as React.CSSProperties}
						key={idx}
					>
						<span className="material-icons md-18">
							done
						</span>
						<span className="challenges__nav__item__number">
							{idx + 1}
						</span>
					</div>
				))}
			</header>
			<div className='challenges-content'>
				<img className="challenges-content__image" src={currentChallenge.subChallengeDTO.urlImage ?? ''} alt={currentChallenge.subChallengeDTO.title} width={914} height={233} />
				<div className="challenges-content__info">
					<h3>
						{currentChallenge.subChallengeDTO.title }
					</h3>
					<p>
						{currentChallenge.subChallengeDTO.description}
					</p>
				</div>
				<div className="challenges-content__button-container ">
					<Link to={`/dashboard?challengeId=${currentChallenge.challengeDTO.idChallenge}&challengeIndex=${currentChallenge.subChallengeIndex}`}>
						<Button gtmClass='secondary'>{currentChallenge.challengeIndex > 0 || currentChallenge.subChallengeIndex > 0 ? 'Continuar' : 'Iniciar'}</Button>
					</Link>
				</div>
			</div>
		</section>
	)
}

export default Challenges